import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { environment } from '@env/environment';
import { merge } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs';
import { I18nService } from './core/i18n.service';

import { BaseComponent } from './shared/base/components/base-component';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
import { Tenant } from './shared/models/classes/Tenant';
import { ForbiddenService } from './shared/services/forbidden.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, ToastContainerComponent],
})
export class AppComponent extends BaseComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private titleService = inject(Title);
  private forbiddenService = inject(ForbiddenService);
  private i18nService = inject(I18nService);

  tenant!: Tenant;

  ngOnInit() {
    this.i18nService.init(environment.supportedLanguages);

    const onNavigationEnd = this.router.events.pipe(filter((event) => event instanceof NavigationEnd));

    const onNavigationStart = this.router.events.pipe(filter((event) => event instanceof NavigationStart));

    // Change page title on navigation or language change, based on route data
    super.addSubscription(
      merge(onNavigationStart).subscribe({
        next: (_event) => {
          this.forbiddenService.allow();
        },
        error: () => {
          /* handled by interceptor */
        },
      }),
    );

    // Change page title on navigation or language change, based on route data
    super.addSubscription(
      merge(onNavigationEnd)
        .pipe(
          map(() => {
            let route = this.activatedRoute;
            while (route.firstChild) {
              route = route.firstChild;
            }
            return route;
          }),
          filter((route) => route.outlet === 'primary'),
          mergeMap((route) => route.data),
        )
        .subscribe({
          next: (event) => {
            const title = event['title'];
            if (title) {
              this.titleService.setTitle(title);
            }
          },
          error: () => {
            /* handled by interceptor */
          },
        }),
    );
  }
}
